export enum AssetPickerFileTypes {
    Jpeg = 'image/jpeg',
    Png = 'image/png'
};
